
import { xCore } from './core';
import { NSToolDraw } from './tool_draw';
import { NSControlsState } from './utils/controls_state';
import { NSFunctions } from './utils/functions';
import { NSMessages } from './utils/messages';
import { NSServerCalls } from './utils/servercalls';
import { NSTables } from './utils/tables';
import { URN as NSURN } from './utils/urn';
import { NSPageLabels } from './page_labels';
import { NSDataModelInfo } from './data_model_info';

import { NSObjDetailsGeo } from './obj_details_geo';

import CheckIcon from 'bootstrap-icons/icons/check-lg.svg?raw';
import EyeSlashIcon from 'bootstrap-icons/icons/eye-slash.svg?raw';


export let NSPDM = {};

NSPDM.init = function()
{
    NSPDMPrivate.init();
	
	this.f_________________________________________ = 	function () { return NSPDMPrivate.f_________________________________________.apply( NSPDMPrivate, arguments ); };
	
	NSPDMPrivate.objs.init();

	this.objs = NSPDMPrivate.objs;

	//window.NSPDM = NSPDM;
	window.NSPDM_ = NSPDM;
	window.NSPDMPrivate_ = NSPDMPrivate;
	
}



let NSPDMPrivate =
{
    private_objs: {
        s_e_div_pdm_holder_id: "pdmpage",
		e_div_pdm_holder: null,
//		settings: null, // settings from config
		
//		map: null,
		
		e_button_pdm_execute: null,
		e_button_pdm_clean: null,
		
		e_div_pdm_loading: null,
//		e_span_pdm_messages: null,
		
		e_pdm_result: null,
		
		e_button_pdm_ordenamento: null,
		e_button_pdm_condicionantes: null,
		
		e_span_marked_area_val: null,
		
		e_pdm_result_ordenamento: null,
		
		e_pdm_result_condicionantes: null,


		o_geo_highlight: null, //	{NSObjDetailsGeo.objs.GeoHighlight}

    },

    init: function()
	{
		this.objs.init();
		
		let private_objs = this.private_objs;

		let moduleName = "NSPDM";
        private_objs.settings = xCore.modules[moduleName].settings;
		
		private_objs.e_div_pdm_holder = document.getElementById(private_objs.s_e_div_pdm_holder_id);
        
		private_objs.o_geo_highlight = new NSObjDetailsGeo.objs.GeoHighlight();  // on destruction call o_geo_highlight.f_destroy
		
		
		this.f_create_page_html();
		
//		private_objs.o_data_struct.f_generate_data_struct();
//		private_objs.o_data_struct.f_sort();

		this.f_hide_result_div();
		
		
	},

    f_show_pdm_loading: function()
	{
		this.private_objs.e_div_pdm_loading.style.display = "";
	},
	f_hide_pdm_loading: function()
	{
		this.private_objs.e_div_pdm_loading.style.display = "none";
	},

    f_create_page_html : function()
    {
        let this_ = this;
		let private_objs = this.private_objs;        

		let s_label_pdm_button_execute_tool_tip = NSPageLabels.f_get_label_text_by_internal_name("label_pdm_button_execute_tool_tip");
		let s_label_pdm_button_clean_tool_tip = NSPageLabels.f_get_label_text_by_internal_name("label_pdm_button_clean_tool_tip");
		let s_label_pdm_intro_text = NSPageLabels.f_get_label_text_by_internal_name("label_pdm_intro_text");

        let s_html = `
			<div class="page-content">
				<div class="actions-buttons-group btn-group btn-group-sm" role="group" aria-label="...">
					<button id="button_pdm_execute" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_pdm_button_execute_tool_tip}">${CheckIcon}</button>
					<button id="button_pdm_clean" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_pdm_button_clean_tool_tip}">${EyeSlashIcon}</button>
				</div>
				<div class="page-card">
					<div class="details">${s_label_pdm_intro_text}</div>
					<div class="div_pdm_loading_holder">
						<div id="div_pdm_loading" class="spinner-border text-danger" role="status"></div>
					</div>
					<div id="pdm_result">
						<div>
							<span><b>Área marcada (m2) : </b></span>
							<span id="span_marked_area_val"></span>
						</div>
						<div class="btn-group btn-group-sm" role="group" >
							<button id="button_pdm_ordenamento" type="button" class="btn btn-danger" title="Ordenamento"><b>Ordenamento</b></button>
							<button id="button_pdm_condicionantes" type="button" class="btn btn-danger" title="Condicionantes"><b>Condicionantes</b></button>
						</div>
						<div id="pdm_result_ordenamento" class="table-container"></div>
						<div id="pdm_result_condicionantes" class="table-container"></div>
					</div>
				</div>
			</div>
        `;
		
		
		NSFunctions.f_dom_elem_append_dom_childs_by_html(private_objs.e_div_pdm_holder, s_html);
		
		private_objs.e_button_pdm_execute = document.getElementById("button_pdm_execute");
		private_objs.e_button_pdm_clean = document.getElementById("button_pdm_clean");
		private_objs.e_div_pdm_loading = document.getElementById("div_pdm_loading");
		
		private_objs.e_pdm_result = document.getElementById("pdm_result");
		
		private_objs.e_button_pdm_ordenamento = document.getElementById("button_pdm_ordenamento");
		private_objs.e_button_pdm_condicionantes = document.getElementById("button_pdm_condicionantes");
		
		private_objs.e_span_marked_area_val = document.getElementById("span_marked_area_val");
		
		
		private_objs.e_pdm_result_ordenamento = document.getElementById("pdm_result_ordenamento");
		
		private_objs.e_pdm_result_condicionantes = document.getElementById("pdm_result_condicionantes");
		
		
		
//		this.f_hide_result_div();

		this.f_hide_pdm_loading();
	

		
		private_objs.e_button_pdm_execute.onclick =	function(){  this_.f_execute_pdm(); };
		private_objs.e_button_pdm_clean.onclick =		function(){  this_.f_clean(); };
		
		private_objs.e_button_pdm_ordenamento.onclick = function(){  this_.f_button_click_ordenamento(); };
		private_objs.e_button_pdm_condicionantes.onclick = function(){  this_.f_button_click_condicionantes(); };
		
		private_objs.e_button_pdm_ordenamento.onclick();
    },

    f_button_click_ordenamento: function()
	{
		let e_button_pdm_ordenamento = this.private_objs.e_button_pdm_ordenamento;
		let e_button_pdm_condicionantes = this.private_objs.e_button_pdm_condicionantes;
		let e_pdm_result_ordenamento = this.private_objs.e_pdm_result_ordenamento;
		let e_pdm_result_condicionantes = this.private_objs.e_pdm_result_condicionantes;
		
		NSControlsState.f_control_disable(e_button_pdm_ordenamento);
		NSControlsState.f_control_enable(e_button_pdm_condicionantes);
		
		e_pdm_result_ordenamento.style.display = "";
		e_pdm_result_condicionantes.style.display = "none";
		
		
	},
	f_button_click_condicionantes: function()
	{
		let e_button_pdm_ordenamento = this.private_objs.e_button_pdm_ordenamento;
		let e_button_pdm_condicionantes = this.private_objs.e_button_pdm_condicionantes;
		let e_pdm_result_ordenamento = this.private_objs.e_pdm_result_ordenamento;
		let e_pdm_result_condicionantes = this.private_objs.e_pdm_result_condicionantes;
		
		NSControlsState.f_control_enable(e_button_pdm_ordenamento);
		NSControlsState.f_control_disable(e_button_pdm_condicionantes);
		
		e_pdm_result_ordenamento.style.display = "none";
		e_pdm_result_condicionantes.style.display = "";
		
	},

    f_validate: function()
	{
        
		var b_res = true;
		
		
		var b_draw_polygon_is_active_and_an_area_is_drawn = NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn();
		if(!b_draw_polygon_is_active_and_an_area_is_drawn)
		{
			b_res = false;
			let s_message = NSPageLabels.f_get_label_text_by_internal_name("label_pdm_validation_error");
            NSMessages.f_show_information(s_message);
			
			NSToolDraw.f_ensure_draw_polygon_is_active();
		}
		
		return b_res;
		
	},

	f_clean: function()
	{
		let this_ = this;
		
		this.f_hide_result_div();
		
        this.private_objs.o_geo_highlight.f_remove_all();
		
	},

    f_execute_pdm: function()
	{
		let this_ = this;
		
		let b_button_active = this.f_button_execute_is_enabled();
		
		if (!b_button_active)
		{
			return;
		}
		
		this.f_button_execute_disable();
		
		this.f_hide_result_div();
		
		
        this.private_objs.o_geo_highlight.f_remove_all();
		
		let b_input_is_valid = this.f_validate();
		
		
		if (b_input_is_valid)			
		{
			
			let f_cb = function(o_resp)
			{
				this_.f_load_all_data_model_info( o_resp,
					()=>{
						this_.f_process_pdm_resp(o_resp);

						this_.f_button_execute_enable();
						this_.f_hide_pdm_loading();
						this_.f_button_click_ordenamento();
					}
				);

				
			};
			
			this.f_show_pdm_loading();

			let o_gj_feature = NSToolDraw.f_get_drawn_geometry_as_geo_json_feature();


			//NSPDMPrivate.o_area_struct.f_reset_checkbox();

			//add drawn geometry to map:
			let s_guid_of_drawn_geometry = NSFunctions.guidGenerator();
			let s_color = "#FF0000";
			let o_style_simple = new NSObjDetailsGeo.objs.GeoHighlightStyleSimpleIn({
                b_add_displacement_to_highlight_an_icon: false,
                a_icon_size_xy: null,	//[width, height]
                color: s_color,
                //opacity: 1.0,
                //width: 4,
                fill_color: s_color,
                //fill_opacity: 0.3
            });

            let o_geo_in = new NSObjDetailsGeo.objs.AddFromGeojsonGeometryIn({
                s_guid: s_guid_of_drawn_geometry,
                urn: null,
                o_geojson_feature_geometry: o_gj_feature.geometry,
                style_simple: o_style_simple,
				f_onclick: null
            });
            this.private_objs.o_geo_highlight.f_add_from_geojson_geometry(o_geo_in);

			NSToolDraw.f_disable();


			//call pdm analysis service:
			/*
            let s_cache_limitation_param_value = NSFunctions.guidGenerator();
            NSServerCalls.geoserver.wfs.f_get_pdm_analysis(
                o_gj_feature.geometry,
                f_cb,
                s_cache_limitation_param_value
            );
			*/
            let o_promise = NSServerCalls.f_get_pdm_analysis(
                o_gj_feature.geometry
            );
			o_promise.then( (o_resp) => { f_cb(o_resp);} );
			
		}
		else
		{
			this_.f_button_execute_enable();
		}
		
	},
	/**
	 * 
	 * @param {*} o_resp
	 * @param {function} f_callback 
	 */
	f_load_all_data_model_info: function(o_resp, f_callback)
	{
		if(o_resp != null && o_resp.features != null)
		{
			let a_features = o_resp.features;
			let o_s_table_urn = {};
			a_features.forEach(o_feature_i => {
				let s_record_urn_i = o_feature_i.properties.urn;
				
				let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_record_urn_i);
				o_s_table_urn[s_table_urn] = s_table_urn;

			});
			let a_s_table_urn = Object.keys(o_s_table_urn);

			//load DataModelInfo for all tables:
			NSDataModelInfo.f_load_table_list____returning_promise(
				{
					a_s_table_urn: a_s_table_urn,
					b_full_info: false
				}
			).then((a_values) => {
				//console.log("---------- pdm - just called f_load_table_list____returning_promise");
				//console.log("---------- tables loaded: " + a_s_table_urn.toString() );
				f_callback();
			})
			.catch(error => {
				let s_error_message = NSPageLabels.f_get_label_text_by_internal_name("common_error_executing_service");
				NSMessages.f_show_error(s_error_message);
				
				console.error(error)
			});

		}
		
	},
    
    f_process_pdm_resp: function(o_resp)
    {
        let this_ = this;
		let private_objs = this.private_objs;
		

		if(o_resp==null || o_resp.features == null)
		{
			let s_error_message = NSPageLabels.f_get_label_text_by_internal_name("common_error_executing_service");
			NSMessages.f_show_error(s_error_message);
			this.f_hide_result_div();
			return;
		}
		
		
		this.f_set_marked_area(o_resp);
		

		let e_pdm_result_ordenamento = private_objs.e_pdm_result_ordenamento;
		let o_in_ord = {
			e_div_res_table: e_pdm_result_ordenamento,
			o_resp: o_resp
		}
		/*
			o_in:
			{
				e_div_res_table: e_pdm_result_ordenamento, 
				o_resp	
			}
		*/
		this.o_table_struct_ordenamento.f_run(o_in_ord);
		
		let e_pdm_result_condicionantes = private_objs.e_pdm_result_condicionantes;
		let o_in_cond = {
			e_div_res_table: e_pdm_result_condicionantes,
			o_resp: o_resp
		}
		/*
			o_in:
			{
				e_div_res_table: e_divToolPDMtableCond, 
				o_resp	
			}
		*/
		this.o_table_struct_condicionantes.f_run(o_in_cond);
		
		
		this.f_show_result_div();
    },

    f_set_marked_area: function(o_resp)
	{
		let private_objs = this.private_objs;
		
		//converting mm2 -> m2;
		//f_marked_area = (f_marked_area!=null && f_marked_area != 0)? f_marked_area/1000000 : 0;
        let a_features = o_resp.features;
        let f_marked_area = (a_features!=null && a_features.length>0)? a_features[0].properties.input_geom_area: 0;

		/*	
				limita casas decimais
				n -> num a arredondar
				iCD -> num max de casas decimais
			NSFunctions.roundNumber(n, iCD) 
		*/
		let iCD = 0;
		let f_rounded = NSFunctions.roundNumber(f_marked_area, iCD);
		f_marked_area = f_rounded;
		
		private_objs.e_span_marked_area_val.innerHTML = '' + f_marked_area +  " ";
	},
	
	f_button_execute_is_enabled: function()
	{
		return NSControlsState.f_control_is_enabled( this.private_objs.e_button_pdm_execute );
	},
	f_button_execute_enable: function()
	{
		return NSControlsState.f_control_enable( this.private_objs.e_button_pdm_execute );
	},
	f_button_execute_disable: function()
	{
		return NSControlsState.f_control_disable( this.private_objs.e_button_pdm_execute );
	},

	f_show_result_div: function()
	{
		this.private_objs.e_pdm_result.style.display = '';
	},

	f_hide_result_div: function()
	{
		this.private_objs.e_pdm_result.style.display = 'none';
	},	
	
	f_collection_is_ordenamento: function(s_table_urn)
	{
		//let b_res = this.private_objs.settings.ordenamento_tables.indexOf(s_table_urn) > -1

        let s_ORD_PREFIX = "ord_";
        let s_table_internal_name = NSURN.f_get_urn_table_name(s_table_urn);
        let b_res = ( s_table_internal_name.substring(0, s_ORD_PREFIX.length) == s_ORD_PREFIX )? true : false;

		return b_res;
	},
	f_collection_is_condicionante: function(s_table_urn)
	{
		//let b_res = this.private_objs.settings.condicionamento_tables.indexOf(s_table_urn) > -1
        
        let s_COND_PREFIX = "cond_";
        let s_table_internal_name = NSURN.f_get_urn_table_name(s_table_urn);
        let b_res = ( s_table_internal_name.substring(0, s_COND_PREFIX.length) == s_COND_PREFIX )? true : false;

		return b_res;
	},
	
	f_get_colors_array: function(i_min_length)
	{
		//Colors:
		var aColors = ["#3366cc", "#dc3912","#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac", "#b77322", "#16d620", "#b91383", "#f4359e", "#9c5935", "#a9c413", "#2a778d", "#668d1c", "#bea413", "#0c5922", "#743411"];
		
		var iNumElems = i_min_length;
		var new_aColors = [];
		while(new_aColors.length < iNumElems)
		{
			new_aColors = new_aColors.concat(aColors); 
		}
		aColors = new_aColors;
		return aColors;
	},


    //Ordenamento
	o_table_struct_ordenamento: {
		private_objs: 
		{
			e_div_res_table: null,
			
			o_resp: null,	//	data received from server
			
			o_table: null,
			
			table_data:
			{
				a_column_name: null,
				
				a_column_cb_holder_div: null
			},
			
//			a_collection: null
			
		
		},
		/*
			o_in:
			{
				e_div_res_table, 
				o_resp	
			}
		*/
		f_run: function (o_param_in)
		{
			let private_objs = this.private_objs;
			private_objs.e_div_res_table = o_param_in.e_div_res_table;
			
			let this_ = this;
			
			//private_objs.o_resp = o_param_in.o_resp;
			NSPDMPrivate.o_table_struct_common.f_store_o_resp(o_param_in.o_resp);
			
			let o_initialize_table_in = {
				private_objs_ref: private_objs
				};
			/*
			o_in:
			{
				private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			}
			*/
			NSPDMPrivate.o_table_struct_common.f_initialize_table(o_initialize_table_in);

			let o_fill_table_in = {
				private_objs_ref: private_objs,
				f_o_resp_object_filter: function(s_table_urn_in){
											return NSPDMPrivate.f_collection_is_ordenamento(s_table_urn_in)
										}
				};
			/*
			o_in:
			{
				private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			}
			*/
			NSPDMPrivate.o_table_struct_common.f_fill_table(o_fill_table_in);
			
		}

	
	},

    //Condicionantes
	o_table_struct_condicionantes: {
		private_objs: 
		{
			e_div_res_table: null,
			
			o_resp: null,	//	data received from server
			
			o_table: null,
			
			table_data:
			{
				a_column_name: null,
				
				a_column_cb_holder_div: null
			},
			
//			a_collection: null
			
		
		},
		/*
			o_in:
			{
				e_div_res_table, 
				o_resp	
			}
		*/
		f_run: function (o_param_in)
		{
			let private_objs = this.private_objs;
			private_objs.e_div_res_table = o_param_in.e_div_res_table;
			
			let this_ = this;
			
			//private_objs.o_resp = o_param_in.o_resp;
			NSPDMPrivate.o_table_struct_common.f_store_o_resp(o_param_in.o_resp);
			
			let o_initialize_table_in = {
				private_objs_ref: private_objs
				};
			/*
			o_in:
			{
				private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			}
			*/
			NSPDMPrivate.o_table_struct_common.f_initialize_table(o_initialize_table_in);
			let o_fill_table_in = {
				private_objs_ref: private_objs,
				f_o_resp_object_filter: function(s_table_urn_in){
											return NSPDMPrivate.f_collection_is_condicionante(s_table_urn_in)
										}
				};
			/*
			o_in:
			{
				private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			}
			*/
			NSPDMPrivate.o_table_struct_common.f_fill_table(o_fill_table_in);
			
		}

	
	},


    o_table_struct_common:
	{
		private_objs_common:
		{
			o_resp: null,
		},

        
		f_o_resp_get_feature_by_record_urn: function(s_record_urn)
		{
			let o_resp = this.private_objs_common.o_resp;
            let a_ = o_resp.features;
            for(let i=0; i<a_.length; i++)
            {
                let o_f_i = a_[i];
                if(o_f_i.properties.urn == s_record_urn)
                {
                    return o_f_i;
                }
            }
            return null;
		},
		
		f_store_o_resp: function(o_resp)
		{
			this.private_objs_common.o_resp = o_resp;
		},
		
		/*
		o_in:
		{
			private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
		}
		*/
		f_initialize_table: function(o_param_in)
		{	
			let this_ = this;
			let private_objs = o_param_in.private_objs_ref;
			
			
			//cb, txt, Área afectada (m2),	(%)
			let a_column_name = ["&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", "", "m2", "%"];
			let aTH_CSS = [];
			let aTD_CSS = [];
			for(let i=0; i<a_column_name.length; i++)
			{
				aTH_CSS.push("results-table-cell");
				aTD_CSS.push("results-table-cell");
			}

			private_objs.table_data.a_column_name = a_column_name;
			private_objs.table_data.a_column_cb_holder_div = [];
			
			if(private_objs.o_table != null)
			{
				private_objs.o_table.destroy();
				private_objs.o_table = null;
			}
			
			//table sort comparisson function
			let f_cmp_sel = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_sel(o1,o2);
			}
			let f_cmp_input_cb = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_input_cb(o1,o2);
			}
			let f_cmp_string = function(o1,o2)
			{
				return NSFunctions.o_comparisson_struct.f_cmp_string(o1,o2);
			}
			
			
			let aColumns = new Array();
			aColumns = aColumns.concat(a_column_name)

			let e_TableHolder = private_objs.e_div_res_table;         
			let sTableCSS = 'table table-sm table-bordered table-hover';//'table table-bordered table-striped table-hover';
			let sTR_CSS = [""];
			let sTR_SELECTED_CSS = "active_tr";//"active_tr";//"active";//"table_tr_selected";
			let b_multiple_selection = false;
			let b_multiple_selection_classic_style = true;
			let b_sortable = true;
			let a_b_col_sortable = null;
			//let a_sort_cmp_function = null;
			let a_sort_cmp_function = [f_cmp_string, f_cmp_string, f_cmp_sel, f_cmp_input_cb];
			
			
			let o_in = {
				eHTMLHolder: e_TableHolder, 
				aColumns: aColumns, 
				sTableCSS: sTableCSS, 
				aTH_CSS: aTH_CSS, 
				aTD_CSS: aTD_CSS, 
				sTR_CSS: sTR_CSS, 
				sTR_SELECTED_CSS: sTR_SELECTED_CSS, 
				b_multiple_selection: b_multiple_selection, 
				b_multiple_selection_classic_style: b_multiple_selection_classic_style,
				b_sortable: b_sortable,
				a_b_col_sortable: a_b_col_sortable,    // default b_sortable determines if all are sortable or not
				a_sort_cmp_function: a_sort_cmp_function, //    ->  a[f(o1,o2)]    -> f returns true if o1 < o2 , default string comparisson...
			};
			
			let table = new NSTables.Objs.Table(o_in);
			private_objs.o_table = table;	
			
			//------------------------------------------
			//Event Handlers:
			//table
			table.addRowClickEventFunction(
				function () {
					//alert("row selected!");
					/*
					o_in:
					{
						private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
					}
					*/
					this_.f_table_on_select_handler_(o_param_in);
			});
			
			//refreshing visibility:
			let b_show_table =  (a_column_name.length > 0)? true: false;


		},
		/*
		o_in:
		{
			private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
		}
		*/
		f_table_on_select_handler_: function(o_param_in)
		{
			var private_objs = o_param_in.private_objs_ref;
			var o_table = private_objs.o_table;
			var a_selected_keys = o_table.getSelection_keys();
			
		},
		/*
		o_in:
		{
			private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			f_o_resp_object_filter		// (f_collection_is_ordenamento || f_collection_is_condicionante) -> bool = f_o_resp_object_filter(s_collection_internal_name)
		}
		*/
		f_fill_table: function(o_param_in)
		{
			let this_ = this;
			let private_objs = o_param_in.private_objs_ref;
			let f_o_resp_object_filter = o_param_in.f_o_resp_object_filter;
			
			let o_resp = this.private_objs_common.o_resp;
			
			let table_data = new NSTables.Objs.DataTable();
			let a_column_name = private_objs.table_data.a_column_name;
			
            let a_features = o_resp.features;
			//var f_marked_area = o_resp.area /1000000;//converting mm2 -> m2;
            let f_marked_area = (a_features!=null && a_features.length>0)? a_features[0].properties.input_geom_area: 0;


            a_features.forEach(o_feature_i => {
                let s_record_urn_i = o_feature_i.properties.urn;
                let s_pdm_info = o_feature_i.properties.pdm_info;
                //let f_marked_area = o_feature_i.properties.input_geom_area;           // m2
                let f_intersected_area = o_feature_i.properties.intersection_area;      // m2
                let f_record_total_area = o_feature_i.properties.geom_area;             // m2
                
                let a_feature_urn_info = NSURN.f_get_urn_info(s_record_urn_i);
                let s_schema_internal_name = a_feature_urn_info[1];
                let s_table_internal_name = a_feature_urn_info[2];
                let s_record_id = a_feature_urn_info[3];
                let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_record_urn_i);
				let o_table_info = NSDataModelInfo.f_get_table_info_by_table_urn(s_table_urn);

				let b_col_is_to_be_added = f_o_resp_object_filter(s_table_urn);
                if(b_col_is_to_be_added)
				{
					let s_pdm_info_complete = o_table_info.external_name + " - " + s_pdm_info;
                    let f_intersected_area_perc = (f_intersected_area / f_marked_area) * 100;
					f_intersected_area_perc = (f_intersected_area_perc>100)? 100 : f_intersected_area_perc;
					
					let s_row_id = "pdm_ord_cond_table__row__" + s_record_urn_i;
					
					//checkbox that enables record area on map
					let s_div_cb_holder_key = NSFunctions.guidGenerator();
					
					let o_in = {
							s_div_cb_holder_key : s_div_cb_holder_key,
							s_record_urn: s_record_urn_i,
							s_pdm_info: s_pdm_info_complete,
							f_intersected_area: f_intersected_area,
							f_intersected_area_perc: f_intersected_area_perc,
							
							private_objs_ref: o_param_in.private_objs_ref
						};
					/*
						o_in: {
							s_div_cb_holder_key,
							s_record_urn,
							s_pdm_info,
							f_intersected_area,
							f_intersected_area_perc,
							
							private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
						}
					*/
					let a_row_values = this.f_aux_get_row_values_(o_in);
					table_data.addRows([a_row_values], [s_row_id]);

                }

            });

			
			var table = private_objs.o_table;
			table.addRows(table_data);
			
			var o_create_col_value_content_in = 
			{
				private_objs_ref: o_param_in.private_objs_ref
			}
			/*
			o_in:
			{
				private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
			}
			*/
			this.f_create_col_checkbox_value_content(o_create_col_value_content_in);
			
			return;
		
		},
		/**
		o_in: {
			s_div_cb_holder_key,
			s_record_urn,
			s_pdm_info,
			f_intersected_area,
			f_intersected_area_perc,
			
			private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
		}
		*/
		f_aux_get_row_values_: function( o_in )
		{
			let s_div_cb_holder_key = o_in.s_div_cb_holder_key;
			let s_record_urn = o_in.s_record_urn;
			let s_pdm_info = o_in.s_pdm_info;
			let f_intersected_area = o_in.f_intersected_area;
			let f_intersected_area_perc = o_in.f_intersected_area_perc;
			
			let private_objs = o_in.private_objs_ref;
			
			let a_column_cb_holder_div = private_objs.table_data.a_column_cb_holder_div;
			a_column_cb_holder_div.push(s_div_cb_holder_key);
					
			let s_field_i_cb_holder_html = '<div \
				id="' + s_div_cb_holder_key + '"\
				k_r_urn="' + s_record_urn + '"\
			></div>';
			
			let s_pdm_info_HTML = s_pdm_info;
	
			/*	
					limita casas decimais
					n -> num a arredondar
					iCD -> num max de casas decimais
				NSFunctions.roundNumber(n, iCD) 
			*/
			let iCD = 0;
			let f_rounded = NSFunctions.roundNumber(f_intersected_area, iCD);
			let s_f_intersected_area_HTML = f_rounded;
			
			iCD = 1;
			f_rounded = NSFunctions.roundNumber(f_intersected_area_perc, iCD);
			let s_f_intersected_area_perc_HTML = f_rounded;
			
			
			let a_row_values = [s_field_i_cb_holder_html, s_pdm_info_HTML, s_f_intersected_area_HTML, s_f_intersected_area_perc_HTML];
			
			
			return a_row_values;
			
		},
		/*
		o_in:
		{
			private_objs_ref,	//reference to o_table_struct_ordenamento or o_table_struct_condicionantes private_objs
		}
		*/
		f_create_col_checkbox_value_content: function(o_param_in)
		{
			let this_ = this;
			let private_objs = o_param_in.private_objs_ref;
			let o_resp = this.private_objs_common.o_resp;
			let a_column_cb_holder_div = private_objs.table_data.a_column_cb_holder_div;
			let o_table = private_objs.o_table;
			
			
			let a_ = a_column_cb_holder_div;
			let a_colors = NSPDMPrivate.f_get_colors_array(a_.length);
			for(let i=0; i<a_.length; i++)
			{
				let s_key_i = a_[i];
				let s_color_i = a_colors[i];
				
				let e_div_i = document.getElementById(s_key_i);
				
				let s_record_urn = e_div_i.getAttribute("k_r_urn");
				

				let e_div_color = document.createElement("div");
				e_div_color.style.height = '13px';
				e_div_color.style.width = '13px';
				e_div_color.style.backgroundColor = s_color_i;
				e_div_color.style.borderRadius = '3px;';

				e_div_i.appendChild(e_div_color);
				
				let o_create_checkbox_in = {
					s_record_urn: s_record_urn,
					s_color: s_color_i,
				};
				
				let e_cb = this.f_create_checkbox(o_create_checkbox_in);
				e_div_i.appendChild(e_cb);
				
				//centering td content:
				// e_div_i.parentElement.style.position = "relative";
				NSFunctions.elem_addClass(e_div_i, "checkbox-cell");

				// e_div_i.style.width = ( NSFunctions.getElementAbsoluteWidth(e_div_color) + NSFunctions.getElementAbsoluteWidth(e_cb) ) + "px";			
			}
		},
		/*
			o_in: {
						s_record_urn	//record urn
						s_color			//color
					}
			returns document element
		*/
		f_create_checkbox: function(o_in)
		{
			let this_ = this;

			let s_record_urn = o_in.s_record_urn;
			let s_color = o_in.s_color;
			
			
			let e_cb = document.createElement("input");
			e_cb.setAttribute("type", "checkbox");
			e_cb.style.float = 'left';
			e_cb.setAttribute("s_record_urn", s_record_urn);
			
			//checkbox behaviour:
			e_cb.onchange = function(e)
			{
				let o_in = 
				{
					e: e,
					e_cb: e_cb,
					s_record_urn: s_record_urn,
					s_color: s_color
				}
				/*
				o_in: {
					e,				//event
					e_cb,			//checkbox document element
					s_record_urn	//record urn
					s_color			//color
				}
				*/
				this_.f_checkbox_value_change(o_in);
				
			}
			
			return e_cb;
			
			
		},
		/*
		o_in: {
			s_guid,
			s_record_urn	//record urn
			s_color,
            o_gj_feature
		}
		*/
		f_show_geometry: function(o_in)
		{
			let s_guid = o_in.s_guid;
			let s_record_urn = o_in.s_record_urn;
			let s_color = o_in.s_color;
			let o_feature = o_in.o_gj_feature;
			let private_objs = this.private_objs;
            let private_objs_global = NSPDMPrivate.private_objs;

			let o_field_geo_value = o_feature.geometry;
			/*
			args:	event, o_ol_feature
			*/
            let f_onclick = function(event, o_geo_json_feature)
			{
				let o_ll = event.coordinate;
				let b_clean_join_list = false;
				let o_geo_json = o_feature;
				let b_go_to = false;

				o_geo_json.id = s_record_urn;

				let o_in = {
					s_urn: s_record_urn,
					b_clean_join_list: b_clean_join_list,
					//o_ll: event.coordinate,
					//s_geometry_internal_name: s_geometry_internal_name,
					o_geo_json: o_geo_json,
					b_go_to: b_go_to
				}

				NSObjDetails.f_open_details_by_feature(o_in);
			}

            let o_style_simple = new NSObjDetailsGeo.objs.GeoHighlightStyleSimpleIn({
                b_add_displacement_to_highlight_an_icon: false,
                a_icon_size_xy: null,	//[width, height]
                color: s_color,
                //opacity: 1.0,
                //width: 4,
                fill_color: s_color,
                fill_opacity: 0.3
            });

            let o_geo_in = new NSObjDetailsGeo.objs.AddFromGeojsonGeometryIn({
                s_guid: s_guid,
                urn: s_record_urn,
                o_geojson_feature_geometry: o_field_geo_value,
                style_simple: o_style_simple,
				f_onclick: f_onclick
            });
            private_objs_global.o_geo_highlight.f_add_from_geojson_geometry(o_geo_in);

			
		},
		/*
		o_in: {
			s_guid,
			s_record_urn	//record urn
		}
		*/
		f_hide_geometry: function(o_in)
		{
            let private_objs_global = NSPDMPrivate.private_objs;

			let s_guid = o_in.s_guid;
			let s_record_urn = o_in.s_record_urn;

			private_objs_global.o_geo_highlight.f_remove(s_guid);
		},
		
		/*
		o_in: {
			e,				//event
			e_cb,			//checkbox document element
			s_record_urn	//record urn
			s_color			//color
		}
		*/
		f_checkbox_value_change: function(o_in)
		{
			let this_ = this;
			//var private_objs = this.private_objs;
			let e = o_in.e;
			let e_cb = o_in.e_cb;
			let s_record_urn = o_in.s_record_urn;
			let s_color = o_in.s_color;
            
			NSControlsState.f_control_disable(e_cb);
			
			let b_checked = e_cb.checked;
			if(b_checked)
			{
                let o_feature = this.f_o_resp_get_feature_by_record_urn(s_record_urn);
                let s_geometry_names = o_feature.geometry_name;//AQUIIIIIIIIIIIIIIIIIIIIIIIIIIIIII TODO TO DO
				
				let f_get_feature_process_result = function(o_resp)
				{
                    if(o_resp != null && o_resp.features.length > 0)
                    {
                        let o_gj_feature = o_resp.features[0];

                        let s_guid = e_cb.____s_guid____;
                        let o_show_geometry_in = {
                            s_guid: s_guid,
                            s_record_urn: s_record_urn,
                            s_color: s_color,
                            o_gj_feature: o_gj_feature
                        }
                        /*
                        o_in: {
                            s_guid,
                            s_record_urn,	//record urn
                            s_color,
                            o_gj_feature
                        }
                        */
                        this_.f_show_geometry(o_show_geometry_in);
                        NSControlsState.f_control_enable(e_cb);

                    }
					
				}

				
				let s_guid = NSFunctions.guidGenerator();
				e_cb.____s_guid____ = s_guid;
				
                let a_record_urn_info = NSURN.f_get_urn_info(s_record_urn);
                let s_schema = a_record_urn_info[1];
                let s_table_name = a_record_urn_info[2];
                let s_record_key = a_record_urn_info[3];
                let s_cache_limitation_param_value = NSFunctions.guidGenerator();
                NSServerCalls.geoserver.wfs.get_feature_by_id_list( s_table_name, s_record_key , null, 
                    function (o_resp) {
                        f_get_feature_process_result(o_resp);
                    },
                    s_cache_limitation_param_value
                );	
                
				
			}
			else{
				var s_guid = e_cb.____s_guid____;
				var o_hide_geometry_in = {
					s_guid: s_guid,
					s_record_urn: s_record_urn
				}
				/*
				o_in: {
					s_guid
					s_record_urn	//record urn
				}
				*/
				this_.f_hide_geometry(o_hide_geometry_in);
				
                NSControlsState.f_control_enable(e_cb);
				
			}
			
			
			
			
			
		},
		/*
		o_in: {
			s_record_urn,
			o_resp,
			
			f_callback
		}
		*/
		f_load_geometries_to_o_details_process_result_: function(o_in)
		{
			let private_objs = this.private_objs;
			let s_record_urn = o_in.s_record_urn;
			let o_resp = o_in.o_resp;
			let f_callback = o_in.f_callback;
			
			let o_feature = this.private_objs_common.o_resp.pdm_info[s_record_urn].feature.features[0];
			
			if(o_resp.success)
			{
				let o_geometries = o_resp.geometries;
				
				//updating feature geometry
				o_feature.geometry = o_geometries[o_in.s_geometry_name];
				
				f_callback();
			}
			else
			{
				let s_error_message = NSPageLabels.f_get_label_text_by_internal_name("label_pdm_execute_error");
				NSMessages.f_show_information(s_error_message);
			}
			
			
		},
	},    



	
    objs:
    {

        init: function()
        {

        }
    }
}